import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthenticatedComponent from '../AuthenticatedComponent';
import WaitingListService from '../../services/WaitingListService.js';
import { WAITINGLIST_REPORT_URL } from '../../constants/WaitingListConstants.js';
import { useSelector } from 'react-redux';
import WaitingListComponent from './subcomponents/WaitingListComponent';

function WaitingList() {
    const [paymentInitiated, setPaymentInitiated] = useState(false);
    const navigate = useNavigate();
    const { _waitingList, _applicationWaitingList } = useSelector(state => state.waitingList);

    useEffect(() => {
        if (_applicationWaitingList.length === 0) {
            WaitingListService.getApplications();
        }
        WaitingListService.getWaitingList();
    }, [_applicationWaitingList.length]);

    const generateReport = () => {
        window.open(
            WAITINGLIST_REPORT_URL,
            '_blank' // <- This is what makes it open in a new window.
        );
    };

    const intiatePayments = (e) => {
        e.preventDefault();
        WaitingListService.startPayment();
        navigate("/waitinglistLetter?type=regning");
    };

    const stopPayments = (e) => {
        e.preventDefault();
        WaitingListService.countToBeDeleted().then((responseData) => {
            var count = responseData;
            var r = window.confirm('Advarsel! Du sletter i alt ' + count + ' person(er) fra ventelisten hvis du trykker OK');
            if (r == true) {
                WaitingListService.stopPayment().then((response) => {
                    window.alert('Betalingsstop planlagt, gennemføres om ' + response + ' minutter, kontakt administrator hvis det skal aflyses');
                });
            }
        });
    };

    const sendFollowup = (e) => {
        e.preventDefault();
        navigate("/waitinglistLetter?type=rykker");
    };

    if (_waitingList) {
        var list1 = [];
        var list2 = [];
        var list3 = [];
        _waitingList.map(function (waitingListEntry) {
            if (waitingListEntry.initiated && waitingListEntry.listtype.letter!="B" && paymentInitiated == false ) {
                setPaymentInitiated(true);
            }
            switch (waitingListEntry.listtype.id) {
                case 1:
                    list1.push(<WaitingListComponent isWaitingList={true} waitingListEntry={waitingListEntry} count={list1.length + 1} ></WaitingListComponent>);
                    break;
                case 2:
                    list2.push(<WaitingListComponent isWaitingList={true} waitingListEntry={waitingListEntry} count={list2.length + 1} ></WaitingListComponent>);
                    break;
                case 3:
                    list3.push(<WaitingListComponent isWaitingList={true} waitingListEntry={waitingListEntry} count={list3.length + 1} ></WaitingListComponent>);
                    break;
                default:
                    break;
            }
        });

    }
    return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-primary" onClick={generateReport}>Udskriv</button>
                        {paymentInitiated ?
                            <React.Fragment>
                                <button className="btn btn-primary ml-1" onClick={stopPayments}>Stop betalingsperiode</button>
                                <button className="btn btn-primary ml-1" onClick={sendFollowup}>Send rykker</button>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <button className="btn btn-primary ml-1" onClick={intiatePayments}>Send regninger (Start ny betalingsperiode)</button>
                            </React.Fragment>
                        }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div id="waitingList">
                                <table className="table table-responsive table-striped table-hover">
                                    <thead className='textAlignLeft'>
                                        <tr>
                                            <th style={{ textAlign: "center", minWidth: "5rem" }}>#</th>
                                            {paymentInitiated && <th className='textAlignLeft'>Betalt</th>}
                                            <th className='textAlignLeft'>Navn</th>
                                            <th className='textAlignLeft'>Adresse</th>
                                            <th className='textAlignLeft'>Email</th>
                                            <th className='textAlignLeft'>Telefon</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list1}
                                        {list2}
                                        {list3}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
    );
}

export default AuthenticatedComponent(WaitingList)